import { TimeSlotAtTrainingAreaDTO } from "./TimeSlotAtTrainingAreaDTO";

export interface TimeSlotDTO {
  id: number | null;
  day: string;
  startTime: string;
  endTime: string;
  timeSlotAtTrainingAreas: TimeSlotAtTrainingAreaDTO[];
}

export const timeSlotDTOInit: TimeSlotDTO = {
  id: null,
  day: "",
  startTime: "",
  endTime: "",
  timeSlotAtTrainingAreas: [],
}
